var _path, _path2, _rect, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowformf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 1.44189C8.25832 1.44189 5.98398 3.25832 4.61127 4.6277C4.241 4.99707 4.24671 5.59258 4.6284 5.95014C6.1569 7.38197 8.83868 9.38426 11.0552 9.36043C13.2584 9.33674 15.5845 7.37518 16.8748 5.9655C17.2142 5.59476 17.1838 5.02749 16.8368 4.66386C15.5264 3.29054 13.6621 1.44189 11.0552 1.44189Z",
    fill: "#ADE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1985 7.69629H18.9754C19.6934 7.69629 20.2754 8.27832 20.2754 8.99629V10.3084C20.2754 11.0264 19.6934 11.6084 18.9754 11.6084H15.7394",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.78381,
    y: 15.374,
    width: 16.4194,
    height: 4.00743,
    rx: 1.25,
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6917 7.79611C14.7153 7.8233 14.7216 7.84843 14.7216 7.86816C14.7216 7.88789 14.7153 7.91303 14.6917 7.94022C14.2376 8.46449 13.4596 9.27282 12.4825 9.94506C11.4999 10.6211 10.3764 11.1182 9.21545 11.1182C8.05452 11.1182 6.93101 10.6211 5.94837 9.94506C4.97129 9.27281 4.19329 8.46449 3.7392 7.94022C3.71565 7.91303 3.70932 7.88789 3.70932 7.86816C3.70932 7.84843 3.71565 7.8233 3.7392 7.79611C4.19329 7.27184 4.9713 6.46351 5.94837 5.79127C6.93101 5.1152 8.05452 4.61816 9.21545 4.61816C10.3764 4.61816 11.4999 5.1152 12.4825 5.79127C13.4596 6.46351 14.2376 7.27184 14.6917 7.79611Z",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.21542,
    cy: 7.86838,
    r: 1.4924,
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowformf);
export default __webpack_public_path__ + "static/media/Show form f.aa67e724c852ad5a6dc75471a6bba75b.svg";
export { ForwardRef as ReactComponent };